'use strict';

function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }

/* jshint esnext: true, loopfunc: true */

var toString = ({}).toString;
var isType = function isType(obj, type) {
    return toString.call(obj) === '[object ' + type + ']';
};

var checkType = {
    isArguments: function isArguments(obj) {
        return isType(obj, 'Arguments');
    },
    isArray: Array.isArray ? Array.isArray : function (obj) {
        return isType(obj, 'Array');
    },
    isArrayLike: function isArrayLike(obj) {
        return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && isFinite(obj.length);
    },
    isBoolean: function isBoolean(obj) {
        return isType(obj, 'Boolean');
    },
    isDate: function isDate(obj) {
        return isType(obj, 'Date');
    },
    isError: function isError(obj) {
        return isType(obj, 'Error');
    },
    isFunction: function isFunction(obj) {
        return isType(obj, 'Function');
    },
    isNull: function isNull(obj) {
        return obj === null;
    },
    isNumber: function isNumber(obj) {
        return isType(obj, 'Number');
    },
    isPlainObject: function isPlainObject(obj) {
        return isType(obj, 'Object');
    },
    isRegExp: function isRegExp(obj) {
        return isType(obj, 'RegExp');
    },
    isString: function isString(obj) {
        return isType(obj, 'String');
    },
    isType: isType,
    isUndefined: function isUndefined(obj) {
        return obj === undefined;
    },
    getType: function getType(obj) {
        var typeStr = toString.call(obj);
        return typeStr.replace(/^\[object /, '').replace(/\]$/, '');
    },
    isObject: function isObject(obj) {
        var type = typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
        return type === 'function' || type === 'object' && !!obj;
    }
};

module.exports = checkType;


/*****************
 ** WEBPACK FOOTER
 ** ./~/zero-text/~/zero-lang/type.js
 ** module id = 36
 ** module chunks = 0
 **/